var _path, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInternetMailServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25977,70a.75019.75019,0,0,0,.75.75H70a.7502.7502,0,0,0,.75-.75V40.6499h-.00464c0-.00671.00488-.01227.00464-.019a.75028.75028,0,0,0-.38623-.63672L64.75,36.87891V10A.7502.7502,0,0,0,64,9.25H16a.7502.7502,0,0,0-.75.75V36.8736L9.63574,39.99414a.75122.75122,0,0,0-.38574.63721c-.00037.01446.00928.02643.00977.04077Zm3.8-.75L35.62354,57.48206l3.97558,2.47448a.74878.74878,0,0,0,.792,0l3.98023-2.47662L66.94006,69.25ZM64.75,38.59424l3.772,2.09326L64.75,43.03436Zm4.5,3.40558V68.763L45.85034,56.55963ZM16.75,10.75h46.5V43.96765L39.99512,58.43652,16.75,43.968Zm-1.5,27.84V43.0343l-3.772-2.34778Zm-4.49023,3.41626,23.385,14.55529-23.385,12.19629Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 19.25,
    width: 36,
    height: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 27.25,
    width: 36,
    height: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 35.25,
    width: 36,
    height: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInternetMailServices);
export default __webpack_public_path__ + "static/media/icon_internet_mail_services.6a1efa3449f700bfa3572b2711dfe61d.svg";
export { ForwardRef as ReactComponent };